var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsLogo2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google_Maps_Logo_2020",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.299,
    height: 16.214,
    viewBox: "0 0 11.299 16.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28044",
    "data-name": "Path 28044",
    d: "M831,239.862a15.748,15.748,0,0,1,1.276,1.887,9.811,9.811,0,0,1,.7,1.782c.141.409.276.533.558.533.309,0,.45-.209.558-.533a9.975,9.975,0,0,1,.676-1.742c1.064-2.006,2.8-3.432,3.775-5.385a6.585,6.585,0,0,0,.643-2.864,5.672,5.672,0,0,0-.634-2.64L831,239.876Z",
    transform: "translate(-827.889 -227.851)",
    fill: "#34a853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28045",
    "data-name": "Path 28045",
    d: "M636.309,326.781a20.17,20.17,0,0,0,2.561,3.669l4.2-4.976a2.206,2.206,0,0,1-1.663.776,2.151,2.151,0,0,1-2.165-2.151,2.328,2.328,0,0,1,.492-1.4c-3.089.459-2.917,1.208-3.432,4.079Z",
    transform: "translate(-635.759 -318.439)",
    fill: "#fbbc04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28046",
    "data-name": "Path 28046",
    d: "M900.675,19.6a5.584,5.584,0,0,1,3.3,2.785l-3.353,4a2.338,2.338,0,0,0,.492-1.4,2.173,2.173,0,0,0-2.151-2.151,2.24,2.24,0,0,0-1.663.767,22.53,22.53,0,0,1,3.379-4Z",
    transform: "translate(-893.314 -19.34)",
    fill: "#4285f4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28047",
    "data-name": "Path 28047",
    d: "M695,1.919A5.612,5.612,0,0,1,699.316-.1a5.742,5.742,0,0,1,1.716.259l-3.366,4A19.245,19.245,0,0,1,695,1.914Z",
    transform: "translate(-693.684 0.1)",
    fill: "#1a73e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28048",
    "data-name": "Path 28048",
    d: "M595.85,160.209a6.453,6.453,0,0,1-.55-2.666,5.629,5.629,0,0,1,1.32-3.643l2.666,2.244-3.432,4.065Z",
    transform: "translate(-595.3 -151.867)",
    fill: "#ea4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsLogo2020);
export default __webpack_public_path__ + "static/media/Google_Maps_Logo_2020.af2371f5f83f354c97bcbca9dac56847.svg";
export { ForwardRef as ReactComponent };